import { render } from "./CustomPasswordField.vue?vue&type=template&id=08c4115a&scoped=true"
import script from "./CustomPasswordField.vue?vue&type=script&lang=js"
export * from "./CustomPasswordField.vue?vue&type=script&lang=js"

import "./CustomPasswordField.vue?vue&type=style&index=0&id=08c4115a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c4115a"]])

export default __exports__